// extracted by mini-css-extract-plugin
export default {"card":"inicio-card_card__4x6oY","icon":"inicio-card_icon__xY6In","title":"inicio-card_title__T6diS"};